export default class Uint16ArrayUtils {
    static concat(...arrays) {
        let requiredLength = 0;
        let currentIndex = 0;
        for (const arr of arrays) {
            requiredLength += arr.length;
        }
        const result = new Uint16Array(requiredLength);
        for (const arr of arrays) {
            result.set(arr, currentIndex);
            currentIndex += arr.length;
        }
        return result;
    }
}
//# sourceMappingURL=Uint16ArrayUtils.js.map